module.exports = __webpack_public_path__ + "static/media/slider-1.987f37cd.webp";